import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MapIconsService} from '../../../services/map-icons.service';
import * as mapboxgl from 'mapbox-gl';
import {FeatureCollection, Geometry} from 'geojson';
import {MapAssetRepresentation} from '../../../model/custom/map/map-asset-representation';
import {AssetRepresentationsService} from '../../../services/asset-representations.service';

@Component({
  selector: 'app-map-filter-details',
  templateUrl: './map-filter-details.component.html',
  styleUrls: ['./map-filter-details.component.scss']
})
export class MapFilterDetailsComponent implements OnInit {

  @Input()
  public representationVisibility: Map<string, boolean>;
  @Input()
  public map: mapboxgl.Map;
  @Input()
  public mapData: FeatureCollection<Geometry>;
  @Input()
  public uniqueMapAssetRepresentations: MapAssetRepresentation[] = [];

  @Input()
  public possibleStatus: string[] = [];

  @Output() mapDataChanged: EventEmitter<FeatureCollection<Geometry>>;

  public toggleActivate: boolean;
  public toggleActivateStatus: boolean;

  public statusSet: Set<string>;

  constructor(public mapIconsService: MapIconsService, public assetRepresentationsService: AssetRepresentationsService) {
    this.statusSet = new Set<string>();
    this.mapDataChanged = new EventEmitter<FeatureCollection<Geometry>>();
  }

  ngOnInit(): void {
    this.toggleActivate = true;
    this.toggleActivateStatus = true;
    this.resetAllStatusSet();
  }

  toggleAllStatus() {
    this.toggleActivateStatus = !this.toggleActivateStatus;

    if (this.toggleActivateStatus) {
      this.resetAllStatusSet();
    } else {
      this.statusSet = new Set<string>();
    }

    this.refreshVisibleRepresentations();
  }

  private resetAllStatusSet() {
    this.statusSet = new Set<string>(this.possibleStatus);
    this.statusSet.add(undefined);
  }

  toggleAllRepresentations(): void {
    this.toggleActivate = !this.toggleActivate;
    for (const key of this.representationVisibility.keys()) {
      this.representationVisibility.set(key, this.toggleActivate);
    }
    this.refreshVisibleRepresentations();
  }

  private refreshVisibleRepresentations(): void {
    const visibleFeatures = this.mapData.features.filter(feature => this.representationVisibility.get(feature.properties.representation) && this.statusSet.has(feature.properties.status));
    const source: mapboxgl.AnySourceImpl = this.map.getSource('data');
    const mapDataFiltered: FeatureCollection<Geometry, { [p: string]: any }> = {
      type: 'FeatureCollection',
      features: visibleFeatures
    };

    if (source.type === 'geojson') {
      source.setData(mapDataFiltered);
      this.mapDataChanged.emit(mapDataFiltered);
    }
  }

  toggleRepresentation(representationName: string): void {
    this.representationVisibility.set(representationName, !this.representationVisibility.get(representationName));
    this.refreshVisibleRepresentations();
  }

  toggleStatus(status: string): void {
    if (this.statusSet.has(status)) {
      this.statusSet.delete(status);
    } else {
      this.statusSet.add(status);
    }
    this.refreshVisibleRepresentations();
  }

}
